import { render, staticRenderFns } from "./ingredient-add.vue?vue&type=template&id=66201446&"
import script from "./ingredient-add.vue?vue&type=script&lang=js&"
export * from "./ingredient-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66201446')) {
      api.createRecord('66201446', component.options)
    } else {
      api.reload('66201446', component.options)
    }
    module.hot.accept("./ingredient-add.vue?vue&type=template&id=66201446&", function () {
      api.rerender('66201446', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/data-dictionary/cartridge-ingredient/ingredient-add.vue"
export default component.exports